import InfiniteScroll from "react-infinite-scroll-component";
import { CircularProgress } from "@mui/material";

export default function AppPagination({ data, children }) {
    const { handleNext, pageLoad, count, list, scrollableTarget } = data || {};
    return (
        <InfiniteScroll
            loader={pageLoad ? <div className="listLoader"><CircularProgress size={25} /></div> : null}
            hasMore={typeof count === "boolean" ? count : list.length != count ? true : false}
            next={() => handleNext(list.length)}
            scrollableTarget={scrollableTarget ?? "scrollableDiv"}
            dataLength={list.length}
            scrollThreshold={0.9}
        >
            {children}
        </InfiniteScroll>
    );
}
